import { query } from '@confluence/query-preloader-tools';

import { ShareAndRestrictButtonQuery } from '../graphql/ShareAndRestrictButtonQuery.graphql';

export function preloadShareAndRestrictButtonQuery(contentId: string) {
	return query({
		query: ShareAndRestrictButtonQuery,
		variables: {
			contentId,
			isContentTypePublicLinkEligible: true,
		},
	});
}
